<template>
  <div>
    <el-form :model="searchForm" inline>
      <el-form-item label="会议日期">
        <el-date-picker
          v-model="searchForm.time"
          :picker-options="pickerOptions"
          :clearable="false"
          size="small"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="searchList()">查询</el-button>
        <!-- <el-button size="mini" type="primary" icon="el-icon-download" @click="downloadPerson()">导出任务未填写人员</el-button> -->
        <el-button :disabled="multipleSelection.length < 1" size="mini" @click="exceptionList(false)" type="primary">批量导出异常清单</el-button>
        <el-button size="mini" type="success" @click="exceptionList(true)">导出全部异常清单</el-button>
      </el-form-item>
    </el-form>
    <div v-if="selectedDate" style="textAlign:center; color:#909399; fontSize:16px; fontWeight:bold">{{ selectedDate }}
      早晚会部门排行榜</div>
    <el-table
      v-loading="loading"
      :data="dataList"
      :header-cell-style="headStyle"
      :show-summary="dataList.length>0"
      :summary-method="summaryMethod"
      :span-method="mergeMethod"
      height="calc(100vh - 430px)"
      size="mini"
      border
      style="margin-top: 10px"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column label="部门" prop="department" align="center" />
      <el-table-column label="排名" prop="ranking" align="center" width="60" class-name="pointer">
        <template slot-scope="scope">
          <span v-if="scope.row.ranking<4" style="color:#67C23A;fontWeight: bold">{{ scope.row.ranking }}</span>
          <span
            v-else-if="scope.row.ranking<lastRamking-2"
            style="color:#444;fontWeight: bold">{{ scope.row.ranking }}</span>
          <span v-else style="fontWeight: bold">{{ scope.row.ranking }}</span>
        </template>
      </el-table-column>
      <el-table-column label="合计总分" prop="total_score" align="center" width="70" class-name="score" />
      <!-- <el-table-column label="任务未填写扣分" align="center" /> -->
      <el-table-column label="预约早会场数" prop="total_moring_meeting" align="center" width="105" />
      <el-table-column label="已开早会场数" prop="alreadyStart_metting" align="center" width="100" />
      <!-- <template slot-scope="scope">
          <span>{{ scope.row.moring_meeting - scope.row.noprogress_meeting }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="未进行早会场数" prop="noprogress_meeting" align="center" width="105">
        <template slot-scope="scope">
          <span>{{ scope.row.noprogress_meeting }}</span>
        </template>
      </el-table-column>
      <el-table-column label="晚会场数" prop="night_meeting" align="center" width="70" />
      <el-table-column label="早会点击开始执行率" prop="moring_rate" align="center" width="105" />
      <el-table-column label="完成会议纪要数" prop="summary" align="center" width="105" />
      <el-table-column label="会议纪要填写率" prop="summary_rank" align="center" width="105" />
      <el-table-column label="总分配任务数" prop="total_task" align="center" width="95" />
      <!-- <el-table-column label="任务状态" align="center">

      </el-table-column> -->
      <el-table-column label="草稿任务" prop="task_draft_nums" align="center" width="80" />
      <el-table-column label="未执行任务" prop="task_unexecuted_nums" align="center" width="85" />
      <el-table-column label="已执行待确认" prop="task_confirm_nums" align="center" width="95" />
      <el-table-column label="确认完成" prop="task_execution_nums" align="center" width="80" />
      <el-table-column label="任务执行率" prop="execute_rank" align="center" width="85" />
      <el-table-column label="会议纪要得分(2分)" prop="summary_score" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.summary_score!==2"
            class="forDetail"
            @click="seeDetails(scope.row.department_id,'summary')">{{ scope.row.summary_score }}</span>
          <span v-else-if="scope.row.summary_score===2">{{ scope.row.summary_score }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会议任务得分(6分)" prop="task_score" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.task_score!==6"
            class="forDetail"
            @click="seeDetails(scope.row.department_id,'task')">{{ scope.row.task_score }}</span>
          <span v-else-if="scope.row.task_score===6">{{ scope.row.task_score }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="异常扣分（2分）" prop="deduction" align="center" width="85">
        <template slot-scope="scope">
          <span class="forDetail" v-if="scope.row.deduction!=='0.00'"  @click="seeDetails(scope.row.department_id,'noprogress')">{{scope.row.deduction}}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="早会点击开始执行得分（2分）" prop="moring_score" align="center" width="85">
        <template slot-scope="scope">
          <span
            v-if="scope.row.moring_score!==2"
            class="forDetail"
            @click="seeDetails(scope.row.department_id,'noprogress')">{{ scope.row.moring_score }}</span>
          <span v-else-if="scope.row.moring_score===2">{{ scope.row.moring_score }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="attention">
      <p>会议纪要填写率：完成会议纪要数/已开早会场数</p>
      <p>会议任务执行率：1-[（任务状态草稿/总分配任务数）*0.7+（任务状态未执行/总分配任务数）*0.1+（任务状态已执行待确认/总分配任务数）*0.2]</p>
      <p>早会点击开始执行率：已开早会场数/预约早会场数</p>
      <p>会议纪要填写得分：会议纪要填写率*2</p>
      <p>会议任务执行得分：会议任务执行率*6</p>
      <p>早会点击开始执行得分：早会点击开始执行率*2</p>
      <p>合计总分：会议纪要填写得分（2分）+ 会议任务执行情况得分（6分）+会议点击开始执行得分（2分）</p>
    </div>
    <!-- 异常弹窗 会议纪要-->
    <el-dialog :visible.sync="popShow" :title="popTitle" :before-close="closePop" width="1100px">
      <div>
        <el-table
          v-loading="popLoading"
          v-show="popType==='summary'"
          :data="summaryData"
          :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}"
          size="mini"
          height="500"
          border>
          <el-table-column label="时间" prop="estimate_start_time" width="160" />
          <el-table-column :show-overflow-tooltip="true" label="会议主题" prop="meeting_subject">
            <template slot-scope="scope">
              <span
                class="forDetail"
                @click="goDetails(scope.row.id)">【{{ scope.row.id }}】{{ scope.row.meeting_subject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="召集人" prop="name" width="100" />
          <el-table-column label="工号" prop="workcode" width="100" />
          <el-table-column label="异常类型"  width="160" >
            <template>未填写会议纪要</template>
          </el-table-column>
        </el-table>
        <el-table
          v-loading="popLoading"
          v-show="popType==='task'"
          :data="taskData"
          :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}"
          :span-method="mergeRow"
          size="mini"
          height="500"
          border>
          <el-table-column label="时间" prop="estimate_start_time" width="160" />
          <el-table-column :show-overflow-tooltip="true" label="会议主题" prop="">
            <template slot-scope="scope">
              <span
                class="forDetail"
                @click="goDetails(scope.row.id)">【{{ scope.row.id }}】{{ scope.row.meeting_subject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="员工姓名" prop="name" width="100" />
          <el-table-column label="工号" prop="workcode" width="100" />
          <el-table-column :show-overflow-tooltip="true" label="任务详情" prop="task_name" width="300" />
          <el-table-column label="异常类型" prop="task_status" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.task_status===0">草稿</span>
              <span v-if="scope.row.task_status===1">已执行待确认</span>
              <span v-if="scope.row.task_status===2">确认完成</span>
              <span v-if="scope.row.task_status===3">未执行</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-loading="popLoading"
          v-show="popType==='noprogress'"
          :data="noprogressData"
          :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}"
          size="mini"
          height="500"
          border>
          <el-table-column label="时间" prop="estimate_start_time" width="160" />
          <el-table-column :show-overflow-tooltip="true" label="会议主题" prop="">
            <template slot-scope="scope">
              <span
                class="forDetail"
                @click="goDetails(scope.row.id)">【{{ scope.row.id }}】{{ scope.row.meeting_subject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="召集人" prop="name" width="100" />
          <el-table-column label="工号" prop="workcode" width="100" />
          <el-table-column label="会议类型" width="160" >
            <template>未点击会议开始</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { gitusers } from '@/api/user'
import { departmentCount, departmentDetails, downloadAllPerson, downloadException } from '@/api/static'
// import axios from 'axios'
export default {
  name: 'TabDepartment',
  props: {
    isDepartment: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      searchForm: {
        time: []
      },
      multipleSelection: [],
      loading: false,
      dataList: [
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      today: '',
      selectedDate: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      departmentId: null, // 部门ID
      summaryData: [], // 纪要数据
      taskData: [], // 任务数据
      noprogressData: [], // 未进行会议数据
      popTitle: '', // 弹窗标题
      popType: '', // 弹窗类型 summary task noprogress
      popShow: false,
      popLoading: false, // 弹窗表格加载loading
      lastRamking: 0 // 最后一名
    }
  },
  watch: {

  },
  created() {
    const now = new Date()
    now.setTime(now.getTime() - 24 * 60 * 60 * 1000)
    const Y = now.getFullYear()
    const M = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
    const D = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    const today = Y + '-' + M + '-' + D
    this.searchForm.time = [today, today]
    this.today = today
    // 从store取存储的时间，防止用户查看详情后再次点击列表，时间重置（点击左侧菜单栏时，重置时间为当前日期）
    this.page = this.$store.state.countParams.page
    this.pageSize = this.$store.state.countParams.page_size
    this.searchForm.time = this.$store.state.countParams.departmentTime.length === 0 ? [today, today] : this.$store.state.countParams.departmentTime
    // this.searchForm.time = this.$store.state.countParams.time.length===0 ? [today, today] : this.$store.state.countParams.time
    if (this.searchForm.time[0] === this.searchForm.time[1]) {
      this.selectedDate = this.searchForm.time[0].replace(/\-/g, '.')
    } else {
      this.selectedDate = this.searchForm.time[0].replace(/\-/g, '.') + ' ~ ' + this.searchForm.time[1].replace(/\-/g, '.')
    }
    this.searchList()
  },
  beforeMount() {

  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 导出未填写人员
    downloadPerson() {
      downloadAllPerson()
        .then(response => {
          if (response) {
            this.fileAnalyze(response, '任务未填写人员.xls')
          } else {
            this.$message.error('解析失败')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 根据部门导出异常清单
    exceptionList(isAll) {
      let department_id = ''
      if (!isAll) {
        const ids = this.multipleSelection.map(item => item.department_id)
        department_id = ids.join(',')
      }
      const params = {
        start_time: this.searchForm.time[0],
        end_time: this.searchForm.time[1],
        department_id: department_id
      }
      downloadException(params).then(response => {
        if (response) {
          this.fileAnalyze(response, '早晚会异常清单.xls')
        } else {
          this.$message.error('解析失败')
        }
      })
    },
    fileAnalyze(response, fileName) {
      if ('download' in document.createElement('a')) {
        // 非IE下载
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(response)
        elink.download = fileName
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else {
        // IE10+下载
        navigator.msSaveBlob(response, fileName)
      }
    },
    headStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return {
          background: '#409EFF',
          color: '#cc4125',
          'text-shadow': '1px 1px 10px #fff'
        }
      } else {
        return {
          background: '#409EFF !important',
          color: '#fff'
        }
      }
    },
    summaryMethod({ columns, data }) {
      // console.log(columns)
      // console.log(data)
      if (data.length === 0) {
        return
      }

      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => { return item[column.property] })
        // 处理数字
        if (!values.every(value => { return isNaN(value) })) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          })
        }
        // 处理百分比
        if (values.every(value => { return this.isString(value) })) {
          let sum = 0
          sum = values.reduce((prev, curr) => {
            const value = parseFloat(curr.substring(0, curr.length - 1))
            const value1 = String(prev).indexOf('%') > -1 ? parseFloat(prev.substring(0, prev.length - 1)) : prev
            if (!isNaN(value)) {
              return value1 + value
            } else {
              return value1
            }
          })
          sums[index] = parseFloat(sum / (values.length)).toFixed(2) + '%'
        }
        if (index === 0) {
          sums[index] = '总计'
        }
        if (index === 1 || index === 2 || index === 16 || index === 17 || index === 18) {
          sums[index] = ''
        }
      })
      return sums
    },
    // 合并分数相等的行，排名并列
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        if (row.rowNum) {
          return {
            rowspan: row.rowNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    isString(obj) {
      return obj === obj + '' && obj.indexOf('%') > -1
    },
    mergeRow({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        if (row.rowNum) {
          return {
            rowspan: row.rowNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    searchList() {
      if (this.searchForm.time[0] === this.searchForm.time[1]) {
        this.selectedDate = this.searchForm.time[0].replace(/\-/g, '.')
      } else {
        this.selectedDate = this.searchForm.time[0].replace(/\-/g, '.') + ' ~ ' + this.searchForm.time[1].replace(/\-/g, '.')
      }
      this.page = 1
      this.getListData()
    },
    getListData() {
      this.loading = true
      const params = {
        start_time: this.searchForm.time[0],
        end_time: this.searchForm.time[1]
        // page: this.page,
        // page_size: this.pageSize
      }
      const obj = {
        time: this.searchForm.time
      }
      // 将选择的时间存起来，再次点开tab时候用此时间填充
      this.$store.dispatch('SET_DEPARTTIME', obj)
      departmentCount(params).then(res => {
        if (res.code === 'success' && res.data.length > 0) {
          this.dataList = res.data
          this.dataList.sort((m, n) => {
            return parseFloat(n.total_score) - parseFloat(m.total_score)
          })
          // 判断分数相等的 处理排名并列
          // this.dataList.forEach(item)
          let handleData = []
          handleData = this.getRepeat(res.data)
          console.log(handleData)
          // 添加合并行数,并设计排名（处理同名次）
          let countSame = 0
          for (let index = 0; index < this.dataList.length; index++) {
            // 已开 = 预约早会场数 - 未进行早会场数
            // this.dataList[index].alreadyStart_metting = this.dataList[index].moring_meeting - this.dataList[index].noprogress_meeting
            handleData.forEach((per, site) => {
              if (this.dataList[index].total_score === per.key) {
                if (per.value === 1) {
                  this.dataList[index].rowNum = 1 // 只有一个同值
                  this.dataList[index].ranking = index + 1 - countSame
                } else {
                  this.dataList[index].rowNum = per.value
                  this.dataList[index].ranking = index + 1 - countSame
                  for (let i = 1; i < per.value; i++) {
                    this.dataList[index + i].rowNum = 0
                    this.dataList[index + i].ranking = index + 1 - countSame
                  }
                  countSame += per.value - 1
                  index = index + per.value
                }
              }
            })
          }
          this.lastRamking = this.dataList[this.dataList.length - 1].ranking
          // console.log('最终数据', this.dataList)
        } else {
          this.dataList = []
        }
        this.loading = false
      })
    },
    seeDetails(id, type) {
      this.popType = type
      this.departmentId = id
      switch (type) {
        case 'summary':
          this.popTitle = this.selectedDate + ' 未填写会议纪要的早晚会'
          this.summaryData = []
          this.popShow = true
          this.getDetailsData()
          break
        case 'task':
          this.popTitle = this.selectedDate + ' 早晚会任务异常清单'
          this.taskData = []
          this.popShow = true
          this.getDetailsData()
          break
        case 'noprogress':
          this.popTitle = this.selectedDate + ' 未进行的早晚会'
          this.noprogressData = []
          this.popShow = true
          this.getDetailsData()
          break
        default:
          this.popShow = false
      }
    },
    closePop() {
      this.popShow = false
      this.popLoading = false
      this.summaryData = []
      this.taskData = []
      this.noprogressData = []
    },
    getDetailsData() {
      const params = {
        department_id: this.departmentId,
        action: this.popType,
        start_time: this.searchForm.time[0],
        end_time: this.searchForm.time[1]
      }
      this.popLoading = true
      departmentDetails(params).then(res => {
        console.log(res)
        this.popLoading = false
        if (res.code === 'success' && res.data && res.data.length > 0) {
          switch (this.popType) {
            case 'summary':
              this.summaryData = res.data
              break
            case 'task':
              // 任务数据格式组装
              res.data.forEach(item => {
                if (item.task.length > 0) {
                  const num = item.task.length
                  item.task.forEach((el, site) => {
                    const json = {
                      estimate_start_time: item.estimate_start_time,
                      id: item.id,
                      meeting_subject: item.meeting_subject,
                      name: el.name,
                      workcode: el.workcode,
                      task_name: el.task_name,
                      task_status: el.task_status,
                      role: el.role,
                      task_id: el.id,
                      rowNum: site === 0 ? num : 0
                    }
                    this.taskData.push(json)
                  })
                }
              })
              break
            case 'noprogress':
              this.noprogressData = res.data
              break
            default:
              this.popShow = false
              this.$message.error('数据异常，请联系管理员')
          }
        } else {
          this.summaryData = []
          this.taskData = []
          this.noprogressData = []
          this.$message.error('获取数据失败，请联系管理员')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询数组中重复的个数 [2,2,4,3,3,3,1,5,6,6]
    getRepeat(arr) {
      // console.log('原数据', arr)
      const array = arr.sort((x, y) => {
        return parseFloat(y.total_score) - parseFloat(x.total_score)
      })
      const result = [
        // {
        //   key:1, // 数字
        //   value:1 // 数量
        // }
      ]
      array.forEach((el, index) => {
        let json = {}
        if (result.length === 0) {
          json = {
            key: el.total_score,
            value: 1
          }
          result.push(json)
        } else {
          const findIndex = this.findInArr(el, result)
          if (findIndex !== -1) {
            result[findIndex].value++
          } else {
            json = {
              key: el.total_score,
              value: 1
            }
            result.push(json)
          }
        }
      })
      return result
    },
    findInArr(num, arr) {
      let find = -1
      arr.forEach((item, index) => {
        if (num.total_score === item.key) {
          find = index
        }
      })
      return find
    },
    goDetails(id) {
      this.$router.push({ name: 'morningDetails', query: { id: id }})
    }
  }
}
</script>
<style lang="scss">
  .pointer {
    color: #cc4125 !important;
  }

  .score {
    background: #f6b26b !important;
    // color: #fff
  }

  .has-gutter {
    .score {
      background: #F5F7FA !important;
    }
  }

  .attention {
    padding: 10px;

    p {
      line-height: 24px;
      padding: 0;
      margin: 0;
      font-size: 14px;
      color: #53bd1f;
      font-weight: bold;
    }
  }

  .forDetail {
    color: #6d9eeb;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #4183ea;
    }
  }
</style>
